import React from "react";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { toast } from "react-toastify";

export default class CopyText extends React.Component {

    constructor(props) {
        super(props);
    }
    
    render () {
        return (
            <CopyToClipboard text={ this.props.text }
                             onCopy={() => toast.info('Copié')}>
                <input
                    defaultValue={ this.props.text }
                    className="form-control"
                    readOnly={true}
                />
            </CopyToClipboard>

        );
    }
}




// WEBPACK FOOTER //
// ./src/components/form/CopyText.js